import { BrandGroupEntity } from '@/entities/brand-group.entity';
import { useSelectionGroupAction } from '@/components/action-buttons/use-selection-group-action';
import { createLocalSelectionSyncAdapter } from '@/components/group-tables/selection-sync-adapter';

type UseSelectionBrandsActionParams = {
    hasPickedBrandGroups: boolean;
    brandGroups: BrandGroupEntity[];
    maxSelectedItems: number | null;
    setPickedBrandGroups?: (val: string[]) => void;
};

type UseSelectionBrandsActionReturn = {
    onAllPickedBrandGroups: () => Promise<void>;
};

export const useSelectionBrandsAction = ({
    hasPickedBrandGroups,
    brandGroups,
    maxSelectedItems,
    setPickedBrandGroups,
}: UseSelectionBrandsActionParams): UseSelectionBrandsActionReturn => {
    const selectionSync = createLocalSelectionSyncAdapter({
        setPickedIds: setPickedBrandGroups,
    });

    const { onAllPickedItems: onAllPickedBrandGroups } = useSelectionGroupAction({
        hasPickedItems: hasPickedBrandGroups,
        allItemIds: brandGroups.map((brandGroup) => brandGroup.id),
        maxSelectedItems,
        setPickedItems: selectionSync.setPickedIds,
    });

    return {
        onAllPickedBrandGroups,
    };
};
